<template>
    <div class="flats-items-viewed" v-if="flatsArr != null">
        <div class="flat-item-viewed" v-for="(item, index) in flatsArr"  :key="item.id">
            <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">
                <div class="item-default item-img" v-if="item != null && item.id != null">
                    <div class="img-in" v-if="item.images.length > 0">
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                    </div>
                </div>
                <div class="item-desc">
                    <div class="item-title">
                        <span class="rooms">{{item.rooms}}</span> {{flatsPage.flats_cards_info.flat_name}}, <span>{{item.area}} <b>м²</b></span>
                        <!-- <div class="btn-to-favorite">
                            <a href="#" class="favorite-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                                <svgIcon name="star" class="icon-star"/>
                            </a>
                        </div> -->
                    </div>
                    <div class="item-info">
                        <ul>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_object_name}}
                                </div>
                                <!-- v-if="item.complexCode != 'LDM'" -->
                                <div class="right" v-if="item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV'">
                                    {{item.complexName.replace(/['"]+/g, '')}}
                                </div>
                                <div class="right" v-else>
                                    {{item.complexName.replace(/\,.*/,'')}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_size}}
                                </div>
                                <div class="right">
                                    {{item.area}} <span>м²</span>
                                </div>
                            </li>
                            <li class="price" v-if="item.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_price}} м²
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(item.meterPrice)}} <span>тг.</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_floor}}
                                </div>
                                <div class="right">
                                    {{item.floor}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_flat_number}}
                                </div>
                                <div class="right">
                                    {{item.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    <span v-if="item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                    <span v-if="item.complexCode == 'SOH'">{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                </div>
                                <div class="right" v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'SOH' && item.complexCode != 'MNC'">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'DSV' || item.complexCode == 'LDM' || item.complexCode == 'LDM-II' || item.complexCode == 'LDM-III' || item.complexCode == 'LDM-IV'">
                                    {{getNumbersOfBlockDiscovery(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'MNC'">
                                    {{ getNumbersOfBlockMonaco(item.blockName) }}
                                </div>
                                <div class="right" v-if="item.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(item.blockName)}}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-item',
        props: ['flatsArr'],
        components: {
        },
        data () {
            return {
                swiperOption: {
					slidesPerView: 4,
					spaceBetween: 10,
                    loop: false,
					// simulateTouch: false,
					speed: 600,
					observer: true,
					observeSlideChildren: true,
                    observeParents: true,
					navigation: {
						nextEl: '.flats-crm-viewed-btn-next',
						prevEl: '.flats-crm-viewed-btn-prev',
					},
					breakpoints: {
						415: {
							slidesPerView: 1,
							spaceBetween: 10
						},
						812: {
							slidesPerView: 2,
							spaceBetween: 10
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 10
						}
					}
				},
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            ucoCRMurl: 'loadUrlCRMuco',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // console.log(this.flatsArr)
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items-viewed.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-viewed.scss';
    // @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>